import { api } from './api';

export interface Category {
  id: string;
  type: string;
  name: string;
  description?: string;
  icon?: string;
  documentCount: number;
}

export interface CreateCategoryRequest {
  name: string;
  description?: string;
  type: string;
  icon?: string;
}

export interface UpdateCategoryRequest {
  id: string;
  name: string;
  description?: string;
  type: string;
  icon: string;
}

class CategoryService {
  async getAllCategories(): Promise<Category[]> {
    const response = await api.get('/categories');
    return response.data;
  }

  async getCategoryById(id: string): Promise<Category> {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  }

  async getCategoryByType(type: string): Promise<Category> {
    const response = await api.get(`/categories/type/${type}`);
    return response.data;
  }

  async createCategory(category: CreateCategoryRequest): Promise<Category> {
    const response = await api.post('/categories', category);
    return response.data;
  }

  async updateCategory(id: string, category: UpdateCategoryRequest): Promise<Category> {
    const response = await api.put(`/categories/${id}`, category);
    return response.data;
  }

  async deleteCategory(id: string): Promise<void> {
    await api.delete(`/categories/${id}`);
  }

  async updateManyCategories(categories: Category[]): Promise<Category[]> {
    const response = await api.put('/categories/batch', categories);
    return response.data;
  }

  async deleteManyCategories(ids: string[]): Promise<void> {
    await api.delete('/categories/batch', { data: ids });
  }
}

export const categoryService = new CategoryService(); 